export const bytesToMegabytes = (bytes: number) => {
  return (bytes / 1024 ** 2).toFixed(2)
}

export const bytesToKilobytes = (bytes: number) => {
  return (bytes / 1000).toFixed(2)
}
